// src/pages/Users/ArbitrageJudo/components/ArbitrageQuickNav.jsx

import React from "react";
import { FaChevronRight } from "react-icons/fa";

export default function ArbitrageQuickNav({ sections = [] }) {
  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (!el) return;

    const isMobile = window.innerWidth < 640;

    // Navbar + QuickNav sticky + petite marge de respiration
    const offset = isMobile ? 230 : 145;

    const y = el.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top: y,
      behavior: "smooth",
    });
  };

  return (
    <nav className="rounded-[1.75rem] border border-slate-200 bg-white p-3 shadow-sm dark:border-slate-800 dark:bg-slate-900 sm:p-4">
      <div className="mb-2 flex items-center justify-between gap-3">
        <div>
          <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-slate-400">
            Navigation rapide
          </p>
          <p className="text-sm font-bold text-slate-950 dark:text-white">
            Aller directement à une rubrique
          </p>
        </div>
      </div>

      <div className="-mx-1 flex gap-2 overflow-x-auto px-1 pb-1">
        {sections.map((section) => (
          <button
            key={section.id}
            type="button"
            onClick={() => scrollToSection(section.id)}
            className="inline-flex min-h-10 shrink-0 items-center gap-2 rounded-2xl bg-slate-100 px-3 text-xs font-bold text-slate-700 transition active:scale-95 dark:bg-slate-800 dark:text-slate-200"
          >
            {section.title}
            <FaChevronRight className="text-[10px] opacity-50" />
          </button>
        ))}
      </div>
    </nav>
  );
}
